import React, { useState } from 'react';
import InnerSection from './InnerSection';

const Ratings = () => {

  return (
    <div className="mt-2">
      <h2 className="page-main-title">Rate Everything</h2>
      <div className="greenData p-3 rounded shadow flex flex-wrap mb-4">
        <p> Love them or loathe them? Rate these topics to build your profile!</p>
      </div>
    <div className="bg-white rounded shadow flex gap-4 flex-wrap">
      <InnerSection/>
    </div>
    </div>     
  );
};

export default Ratings;